
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('linearGradient',{attrs:{"id":"a","x1":"-279.23","y1":"387.32","x2":"-280.15","y2":"387.03","gradientTransform":"matrix(20 0 0 -20 5605 7755)"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#feeeb3"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#b0884b"}})])]),_c('path',{attrs:{"d":"M12.61 0l-8 7.94H0V20h20V7.94h-6.09v.86h5.22v10.34H.87V8.8h3.48v2.59h3.22l8.26-8.19zM5.22 8.8v-.26l7.39-7.33 2 2-7.4 7.31h-2zm-.87 6h11.3V14H4.35z","fill":"url(#a)"}})])
          )
        }
      }
    